import React, { memo } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";

import { CUSTOM_MESSAGES, LABEL } from '@veriables';
import FullWithModal from '@components/common/Modal/FullWidthModal';
import KeyboardForOrder from '@components/OrderMenuTopScreen/keyboardForOrderMenuCopy';
import ModalHeader from '@components/common/ModalHeader/index';
import Loader from '@components/common/Loader/newLoaderModal';
import { setPosition, renameSeat, setSeat } from '@reducers/orders';
import { updateChecksAfterResponse } from '@reducers/storeChecks';
import { setErrorPopUp } from '@reducers/notification';
import { getObjectValue } from '@utility/utills';


const CheckNameEditModal = ({ isOpen, closeModal, ...props }) => {
    const { serverAppTheme, position, deviceInfo, renameSeat, updateChecksAfterResponse, setPosition, setSeat, check, userInfo, setErrorPopUp, loading } = props; // Redux Imports

    const submitSeatName = data => {
        const dataToSend = {
            storeId: deviceInfo?.storeId,
            deviceId: deviceInfo?.deviceId,
            employeeId: getObjectValue(() => userInfo?.id, null),
            employeeCard: getObjectValue(() => userInfo?.employeeCard, null),
            checkHeaderId: check?.id,
            seatId: position?.id,
            name: data,
        };
        renameSeat(dataToSend).then(res => {
            updateChecksAfterResponse(res);
            closeModal()
            setPosition({ ...position, name: data });
            setSeat(res);
        });
    };
    return (
        <FullWithModal
            isOpen={isOpen}
            customClass2={cn('w-100 h-100 position-relative')}
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '100%',
                pointerEvents: 'auto',
                backgroundColor: serverAppTheme?.popUp_bg,
                backgroundClip: 'padding-box',
                border: '0',
                boxShadow: serverAppTheme?.popUp_box_shadow,
            }}
        >
            <>{loading && <Loader />}</>
            <div className="col-12 px-0 justify-content-center align-items-center position-relative text-center">
                <ModalHeader
                    isTab={props?.check?.tab}
                    stationName={props?.check?.stationName}
                    tileHeader="Rename Seat"
                    seatNumber={props?.check?.number}
                />
                <KeyboardForOrder
                    name="seatName"
                    type="textDefaultCaps"
                    isOpen={isOpen}
                    specialValue={position.name ? String(position.name) : ''}
                    customClass="mt-2 py-3"
                    placeholder={CUSTOM_MESSAGES().ENTER_SEAT_NAME}
                    buttonName={LABEL().SUBMIT}
                    onSubmit={submitSeatName}
                    orderMenuKey={true}
                    serverAppTheme={serverAppTheme}
                    header="Please enter the seat name"
                    cancelBtnName={LABEL().CANCEL}
                    onclose={() => closeModal()}
                    setErrorPopUp={setErrorPopUp}
                />
            </div>
        </FullWithModal>
    )
}


const mapStateToProps = ({ theme, orders, oauth }) => ({
    serverAppTheme: theme.serverAppTheme,
    position: orders.position,
    deviceInfo: oauth.deviceInformation,
    userInfo: oauth.loggedInUserData,
    check: orders.seats,
    loading: orders.loading,
})

const mapDispatchToProps = (dispatch) => bindActionCreators({
    renameSeat,
    setPosition,
    setSeat,
    updateChecksAfterResponse,
    setErrorPopUp,
    setErrorPopUp
}, dispatch);

const MemoizedCheckNameEditModal = memo(CheckNameEditModal)

export default connect(mapStateToProps, mapDispatchToProps)(MemoizedCheckNameEditModal);